import { Onboarding, type OnboardProfile } from "./onboarding/Onboarding.tsx";
import { Library } from "./library/Library.tsx";
import { Room } from "./room/Room.tsx";

/**
 * Flow router:
 *   ?room=<id>&movie=<id>  → the watch room (a shared party link goes straight here)
 *   not signed up / ?signup → onboarding (Google → password)
 *   signed up               → the movie library (browse → start a party)
 */
export function App() {
  const search = new URLSearchParams(window.location.search);
  const room = search.get("room");
  const movie = search.get("movie");
  const authed = localStorage.getItem("mov_onboarded") === "1";

  // 1. A watch-party link → the room, for anyone who has the link.
  if (room) return <Room roomId={room} movieId={movie} />;

  // 2. First visit (or forced) → onboarding.
  if (!authed || search.has("signup")) {
    return (
      <Onboarding
        onDone={(profile: OnboardProfile) => {
          localStorage.setItem("mov_onboarded", "1");
          localStorage.setItem("mov_profile", JSON.stringify(profile));
          // assign() always navigates (unlike setting .search to its current
          // value, a no-op on a query-less URL that left new users stuck here).
          window.location.assign(window.location.pathname); // land in the library
        }}
      />
    );
  }

  // 3. Signed up → browse the library.
  return <Library />;
}
